import type { LocationManagerRoleEnum } from "@sidegigllc/api/client";
import React from "react";
import { AuthContext } from "./providers/Root/context";

export const useAuth = () => React.useContext(AuthContext);
export const useIsAdmin = () => useAuth().user?.is_gigpro_admin ?? false;

export const useUserLocationRoles = () => {
  const roles = useAuth().user?.managed_locations;
  return (
    roles?.reduce(
      (acc, location) => {
        acc[location.location_id] = location.role;
        return acc;
      },
      {} as Record<number, LocationManagerRoleEnum>,
    ) ?? {}
  );
};
export const useUserRoleForLocation = (locationId: number) => {
  const locationRoles = useUserLocationRoles();
  return locationRoles[locationId];
};
const useUserOrganizationRoles = () => {
  const roles = useAuth().user?.organization_roles;
  return (
    roles?.reduce<Record<string, LocationManagerRoleEnum>>((acc, organization) => {
      acc[organization.organization_id] = organization.role;
      return acc;
    }, {}) ?? {}
  );
};
export const useUserRoleForOrganization = (organizationId: string) => {
  const organizationRoles = useUserOrganizationRoles();
  return organizationRoles[organizationId];
};
